import { BottomSheetContent as UiBottomSheetContent, styledForMobile } from "@l2r-front/l2r-ui"

export const BottomSheetContent = styledForMobile(UiBottomSheetContent)({
    display: "flex",
    flexDirection: "column",
    flex: 1,
})